<li class="folder-item">
  <div class="folder-row">
    <button class="folder-toggle" type="button" [attr.aria-expanded]="showContents" (click)="toggleContents()">
      <i class="bi" [class.bi-caret-right-fill]="!showContents" [class.bi-caret-down-fill]="showContents" aria-hidden="true"></i>
      <i class="bi bi-folder" aria-hidden="true"></i>
      <span>{{ folderName }}</span>
    </button>
    @if (archive_type === 0) {
      <button class="folder-save" type="button" [attr.aria-label]="'Copia e cancella ' + folderName"
        (click)="copyAndDeleteFolder(path ? path + '/' + folderName : folderName)">
        <i class="bi bi-floppy2-fill" aria-hidden="true"></i>
      </button>
    }
  </div>

  @if (showContents) {
    <ul class="archive-list">
      @for (subFolder of folders; track subFolder) {
        <app-folder [folderName]="subFolder" [path]="path ? path + '/' + folderName : folderName"
          [archive_type]="archive_type" (saveArticle_folder)="saveArticle($event)"></app-folder>
      }
      @for (file of files; track file) {
        <li class="file-row" [title]="file.modified">
          <i class="bi bi-file-earmark-text" aria-hidden="true"></i>
          <span>{{ file.name }}</span>
          <span class="file-size">{{ file.size }} MB</span>
        </li>
      }
      @if (contentsLoaded && folders.length === 0 && files.length === 0) {
        <li class="archive-empty">Cartella vuota.</li>
      }
    </ul>
  }
</li>
